// Mock data for MyFitnessPal clone
// Sourced inspiration from open USDA-like food data sets

export const user = {
  id: 'u1',
  name: 'Alex Morgan',
  username: '@alexmorgan',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop',
  goal: 'Lose Weight',
  startWeight: 185,
  currentWeight: 172.4,
  goalWeight: 160,
  height: "5'10\"",
  age: 29,
  streak: 47,
  joinedDate: 'Mar 2023',
};

export const dailyGoals = {
  calories: 2150,
  carbs: 269, // grams
  fat: 72,
  protein: 108,
  sugar: 60,
  fiber: 38,
  sodium: 2300,
  cholesterol: 300,
  water: 8, // cups
};

export const todayConsumed = {
  calories: 1342,
  carbs: 168,
  fat: 41,
  protein: 78,
  sugar: 32,
  fiber: 18,
  sodium: 1420,
  cholesterol: 165,
  water: 5,
  exercise: 320,
};

export const foodDatabase = [
  { id: 'f1', name: 'Oatmeal with Berries', brand: 'Quaker', serving: '1 cup (240g)', calories: 320, carbs: 56, fat: 6, protein: 12, sugar: 14, fiber: 8, sodium: 140 },
  { id: 'f2', name: 'Greek Yogurt, Plain', brand: 'Chobani', serving: '1 container (170g)', calories: 130, carbs: 9, fat: 0, protein: 23, sugar: 6, fiber: 0, sodium: 65 },
  { id: 'f3', name: 'Banana, Medium', brand: 'Generic', serving: '1 medium (118g)', calories: 105, carbs: 27, fat: 0, protein: 1, sugar: 14, fiber: 3, sodium: 1 },
  { id: 'f4', name: 'Grilled Chicken Breast', brand: 'Generic', serving: '4 oz (113g)', calories: 187, carbs: 0, fat: 4, protein: 35, sugar: 0, fiber: 0, sodium: 84 },
  { id: 'f5', name: 'Brown Rice, Cooked', brand: 'Generic', serving: '1 cup (195g)', calories: 216, carbs: 45, fat: 2, protein: 5, sugar: 1, fiber: 4, sodium: 10 },
  { id: 'f6', name: 'Mixed Salad Greens', brand: 'Generic', serving: '2 cups (60g)', calories: 15, carbs: 3, fat: 0, protein: 1, sugar: 1, fiber: 2, sodium: 20 },
  { id: 'f7', name: 'Almonds, Raw', brand: 'Generic', serving: '1 oz (28g)', calories: 164, carbs: 6, fat: 14, protein: 6, sugar: 1, fiber: 4, sodium: 0 },
  { id: 'f8', name: 'Egg, Large', brand: 'Generic', serving: '1 large (50g)', calories: 72, carbs: 0, fat: 5, protein: 6, sugar: 0, fiber: 0, sodium: 71 },
  { id: 'f9', name: 'Avocado', brand: 'Generic', serving: '1/2 medium (100g)', calories: 160, carbs: 9, fat: 15, protein: 2, sugar: 0, fiber: 7, sodium: 7 },
  { id: 'f10', name: 'Whole Wheat Bread', brand: 'Dave\u2019s Killer Bread', serving: '1 slice (45g)', calories: 110, carbs: 22, fat: 1, protein: 5, sugar: 4, fiber: 5, sodium: 180 },
  { id: 'f11', name: 'Peanut Butter', brand: 'Jif Natural', serving: '2 tbsp (32g)', calories: 190, carbs: 7, fat: 16, protein: 8, sugar: 3, fiber: 2, sodium: 140 },
  { id: 'f12', name: 'Apple, Medium', brand: 'Generic', serving: '1 medium (182g)', calories: 95, carbs: 25, fat: 0, protein: 0, sugar: 19, fiber: 4, sodium: 2 },
  { id: 'f13', name: 'Salmon, Atlantic', brand: 'Generic', serving: '4 oz (113g)', calories: 233, carbs: 0, fat: 14, protein: 25, sugar: 0, fiber: 0, sodium: 60 },
  { id: 'f14', name: 'Sweet Potato, Baked', brand: 'Generic', serving: '1 medium (150g)', calories: 130, carbs: 30, fat: 0, protein: 2, sugar: 9, fiber: 4, sodium: 70 },
  { id: 'f15', name: 'Black Coffee', brand: 'Starbucks', serving: '1 grande (16 fl oz)', calories: 5, carbs: 0, fat: 0, protein: 0, sugar: 0, fiber: 0, sodium: 10 },
  { id: 'f16', name: 'Protein Shake, Vanilla', brand: 'Premier Protein', serving: '1 bottle (11.5 fl oz)', calories: 160, carbs: 5, fat: 3, protein: 30, sugar: 1, fiber: 1, sodium: 230 },
];

export const exerciseDatabase = [
  { id: 'e1', name: 'Running, 6 mph (10 min/mile)', type: 'cardio', caloriesPerMin: 11.4 },
  { id: 'e2', name: 'Walking, 3.5 mph (brisk)', type: 'cardio', caloriesPerMin: 4.3 },
  { id: 'e3', name: 'Cycling, moderate', type: 'cardio', caloriesPerMin: 8.0 },
  { id: 'e4', name: 'Swimming, freestyle', type: 'cardio', caloriesPerMin: 9.8 },
  { id: 'e5', name: 'Weight Lifting, general', type: 'strength', caloriesPerMin: 5.5 },
  { id: 'e6', name: 'Yoga, Hatha', type: 'flexibility', caloriesPerMin: 3.0 },
  { id: 'e7', name: 'HIIT Training', type: 'cardio', caloriesPerMin: 12.5 },
  { id: 'e8', name: 'Elliptical Trainer', type: 'cardio', caloriesPerMin: 7.2 },
  { id: 'e9', name: 'Rowing Machine', type: 'cardio', caloriesPerMin: 8.5 },
  { id: 'e10', name: 'Pilates', type: 'flexibility', caloriesPerMin: 3.5 },
];

export const initialDiary = {
  Breakfast: [
    { ...{ id: 'f1', name: 'Oatmeal with Berries', brand: 'Quaker', serving: '1 cup (240g)', calories: 320, carbs: 56, fat: 6, protein: 12 }, qty: 1, logId: 'l1' },
    { ...{ id: 'f15', name: 'Black Coffee', brand: 'Starbucks', serving: '1 grande', calories: 5, carbs: 0, fat: 0, protein: 0 }, qty: 1, logId: 'l2' },
  ],
  Lunch: [
    { ...{ id: 'f4', name: 'Grilled Chicken Breast', brand: 'Generic', serving: '4 oz', calories: 187, carbs: 0, fat: 4, protein: 35 }, qty: 1.5, logId: 'l3' },
    { ...{ id: 'f5', name: 'Brown Rice, Cooked', brand: 'Generic', serving: '1 cup', calories: 216, carbs: 45, fat: 2, protein: 5 }, qty: 1, logId: 'l4' },
    { ...{ id: 'f6', name: 'Mixed Salad Greens', brand: 'Generic', serving: '2 cups', calories: 15, carbs: 3, fat: 0, protein: 1 }, qty: 1, logId: 'l5' },
  ],
  Dinner: [],
  Snacks: [
    { ...{ id: 'f12', name: 'Apple, Medium', brand: 'Generic', serving: '1 medium', calories: 95, carbs: 25, fat: 0, protein: 0 }, qty: 1, logId: 'l6' },
    { ...{ id: 'f7', name: 'Almonds, Raw', brand: 'Generic', serving: '1 oz', calories: 164, carbs: 6, fat: 14, protein: 6 }, qty: 1, logId: 'l7' },
  ],
};

export const initialExerciseLog = [
  { id: 'el1', name: 'Running, 6 mph', minutes: 28, calories: 320, time: '7:15 AM' },
];

export const recipes = [
  {
    id: 'r1',
    title: 'Grilled Salmon Buddha Bowl',
    image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=600&h=400&fit=crop',
    calories: 485,
    time: '25 min',
    servings: 2,
    tags: ['High Protein', 'Heart Healthy'],
    rating: 4.8,
  },
  {
    id: 'r2',
    title: 'Mediterranean Chickpea Salad',
    image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=600&h=400&fit=crop',
    calories: 320,
    time: '15 min',
    servings: 4,
    tags: ['Vegan', 'Low Calorie'],
    rating: 4.6,
  },
  {
    id: 'r3',
    title: 'Avocado Toast with Egg',
    image: 'https://images.unsplash.com/photo-1525351484163-7529414344d8?w=600&h=400&fit=crop',
    calories: 380,
    time: '10 min',
    servings: 1,
    tags: ['Breakfast', 'Vegetarian'],
    rating: 4.9,
  },
  {
    id: 'r4',
    title: 'Chicken & Sweet Potato Skillet',
    image: 'https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?w=600&h=400&fit=crop',
    calories: 520,
    time: '35 min',
    servings: 4,
    tags: ['High Protein', 'Dinner'],
    rating: 4.7,
  },
  {
    id: 'r5',
    title: 'Berry Protein Smoothie Bowl',
    image: 'https://images.unsplash.com/photo-1623065422902-30a2d299bbe4?w=600&h=400&fit=crop',
    calories: 295,
    time: '5 min',
    servings: 1,
    tags: ['Breakfast', 'High Protein'],
    rating: 4.5,
  },
  {
    id: 'r6',
    title: 'Veggie Stir Fry with Tofu',
    image: 'https://images.unsplash.com/photo-1512058564366-18510be2db19?w=600&h=400&fit=crop',
    calories: 365,
    time: '20 min',
    servings: 2,
    tags: ['Vegan', 'Quick'],
    rating: 4.4,
  },
];

export const communityPosts = [
  {
    id: 'p1',
    author: 'Sarah Chen',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop',
    time: '2h ago',
    text: 'Hit my goal weight today! 30 lbs down since January. Consistency really is everything. Thank you to this community for keeping me motivated! \u{1F4AA}',
    likes: 342,
    comments: 58,
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=400&fit=crop',
  },
  {
    id: 'p2',
    author: 'Marcus Johnson',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop',
    time: '4h ago',
    text: 'Meal prep Sunday done! 5 days of high-protein lunches ready to go. Anyone else prepping today?',
    likes: 128,
    comments: 22,
    image: 'https://images.unsplash.com/photo-1547592180-85f173990554?w=600&h=400&fit=crop',
  },
  {
    id: 'p3',
    author: 'Priya Patel',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop',
    time: '6h ago',
    text: 'First 5K ever completed in 32 minutes! Six months ago I couldn\u2019t run for 60 seconds. Trust the process.',
    likes: 521,
    comments: 89,
    image: null,
  },
  {
    id: 'p4',
    author: 'David Kim',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop',
    time: '12h ago',
    text: 'Pro tip: track your water intake! I noticed huge energy boost after hitting 8 cups consistently for 2 weeks.',
    likes: 89,
    comments: 14,
    image: null,
  },
];

// 30-day weight history (slight downward trend)
export const weightHistory = Array.from({ length: 30 }, (_, i) => {
  const day = 29 - i;
  const baseWeight = 178 - i * 0.18 + Math.sin(i / 3) * 0.6;
  const date = new Date();
  date.setDate(date.getDate() - day);
  return {
    date: date.toISOString().slice(0, 10),
    weight: Number(baseWeight.toFixed(1)),
  };
}).reverse().reverse();

// 7-day calorie history
export const calorieHistory = [
  { day: 'Mon', consumed: 1980, goal: 2150 },
  { day: 'Tue', consumed: 2245, goal: 2150 },
  { day: 'Wed', consumed: 1830, goal: 2150 },
  { day: 'Thu', consumed: 2090, goal: 2150 },
  { day: 'Fri', consumed: 1750, goal: 2150 },
  { day: 'Sat', consumed: 2310, goal: 2150 },
  { day: 'Sun', consumed: 1342, goal: 2150 },
];

export const stepsToday = 7842;
export const stepsGoal = 10000;

export const friends = [
  { id: 'fr1', name: 'Sarah Chen', avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop', streak: 124 },
  { id: 'fr2', name: 'Marcus Johnson', avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop', streak: 58 },
  { id: 'fr3', name: 'Priya Patel', avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop', streak: 203 },
];
